<div class="section">
  <h3>{{title()}}</h3>
  <div class="results">
    @for(search of items; track $index) {
      <div class="row" (click)="selectSearchTerm(search)">
        <div class="image">
          @switch(type()) {
            @case('recent') {
              <img src="assets/icons/c2u-recent.svg">
            }
            @case('popular') {
              <img src="assets/icons/c2u-popular.svg">
            }
          }
        </div>
        <p>{{search}}</p>
      </div>
    }
    
  </div>
</div>